import {Component} from '@angular/core';
import {SideNavbarComponent} from '../../components/side-navbar/side-navbar.component';
import {MenuBarComponent} from '../../components/menu-bar/menu-bar.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-main-layout',
  imports: [
    SideNavbarComponent,
    MenuBarComponent,
    RouterOutlet,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {

}
